import { Button, Heading, Stack, Spinner, Center, Box } from '@chakra-ui/react'
import { createFileRoute, getRouteApi, Link } from '@tanstack/react-router'
import { FaArrowLeft } from 'react-icons/fa6'
import { Route as encodingPresetsListRoute } from '@routes/_auth/o/$orgId/encodingPresets'
import { UpdateEncodingPresetForm } from '@features/encodingPreset/components/UpdateEncodingPresetForm'
import { useGetEncodingPresetQuery } from '@features/encodingPreset/api'

const routeApi = getRouteApi(
  '/_auth/o/$orgId/encodingPresets/$encodingPresetId'
)

const BackButton = () => {
  const { orgId } = routeApi.useParams()
  return (
    <Box>
      <Link to={encodingPresetsListRoute.to} params={{ orgId }}>
        <Button leftIcon={<FaArrowLeft />} size="xs">
          Back to Encoding Presets
        </Button>
      </Link>
    </Box>
  )
}

const UpdateEncodingPresetRoute = () => {
  const { encodingPresetId } = routeApi.useParams()
  const {
    data: encodingPreset,
    isLoading,
    error,
  } = useGetEncodingPresetQuery(encodingPresetId)

  if (isLoading) {
    return (
      <Center py={12}>
        <Spinner size="lg" />
      </Center>
    )
  }

  if (error || !encodingPreset) {
    return (
      <Stack spacing={4}>
        <BackButton />
        <Heading size="lg" color="red.500">
          Error loading encoding preset
        </Heading>
      </Stack>
    )
  }

  return (
    <Stack spacing={4}>
      <BackButton />
      <UpdateEncodingPresetForm encodingPreset={encodingPreset} />
    </Stack>
  )
}

export const Route = createFileRoute(
  '/_auth/o/$orgId/encodingPresets/$encodingPresetId'
)({
  component: UpdateEncodingPresetRoute,
  beforeLoad: () => ({ getTitle: () => 'Update Encoding Preset' }),
  loader: ({ params }) => ({
    crumb: 'Edit',
  }),
})
